import React from "react";
import { Sparkles } from "lucide-react";

export const DemoBadge = ({ variant = "default" }) => {
  const isCompact = variant === "compact";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold tracking-wide ${
        isCompact ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs"
      }`}
      style={{
        background: "var(--accent-gold-soft)",
        color: "var(--accent-ink-dark)",
        border: "1px solid var(--accent-gold)",
      }}
      data-testid="demo-badge"
    >
      <Sparkles className={isCompact ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {isCompact ? "Demo" : "Showcase Demo"}
    </span>
  );
};
